import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { BookOpenIcon, HeartIcon, MessageCircleIcon, UsersIcon } from 'lucide-react';
const valuePoints = [{
  icon: <BookOpenIcon className="w-5 h-5" data-id="element-91" />,
  text: 'Distintas temáticas para diferentes momentos y necesidades'
}, {
  icon: <HeartIcon className="w-5 h-5" data-id="element-92" />,
  text: 'Enseñanzas claras y adaptadas al lenguaje de los niños'
}, {
  icon: <MessageCircleIcon className="w-5 h-5" data-id="element-93" />,
  text: 'Preguntas para reflexionar y conversar en familia'
}, {
  icon: <UsersIcon className="w-5 h-5" data-id="element-94" />,
  text: 'Ideal para el hogar, la iglesia o el aula'
}];
const themes = [{
  label: 'Amor',
  bg: '#FDF2EC'
}, {
  label: 'Fe',
  bg: '#EAF2F8'
}, {
  label: 'Perdón',
  bg: '#F0F7F2'
}, {
  label: 'Gratitud',
  bg: '#FEF6E8'
}, {
  label: 'Obediencia',
  bg: '#EEF0F8'
}, {
  label: 'Oración',
  bg: '#FDF8F2'
}, {
  label: 'Bondad',
  bg: '#F0F7F2'
}, {
  label: 'Amistad',
  bg: '#FDF2EC'
}, {
  label: 'Confianza en Dios',
  bg: '#EAF2F8'
}];
export function ParabolasHighlightSection() {
  return <section className="py-0" style={{
    background: 'linear-gradient(180deg, var(--color-cream) 0%, var(--color-off-white) 100%)'
  }} data-id="element-95">
      <div className="container mx-auto px-4" data-id="element-96">
        <div className="max-w-3xl mx-auto" data-id="element-97">
          <FadeIn data-id="element-98"></FadeIn>
        </div>
      </div>
    </section>;
}